import React from 'react'
import styled from 'styled-components'
import { breakpoint, getColor } from '../../shared/theme'
import Heading from '../../elements/typography/sectionHeading'
import ContentContainer from '../contentContainer'
import BackgroundImage from '../backgroundImage'

const SectionWrapper = styled.section`
	padding: 37px 0 0;
	background-color: ${getColor('black')};

	@media ${breakpoint('tablet')} {
		padding: 69px 0 0px;
		background-color: ${getColor('white')};
	}

	@media ${breakpoint('laptop')} {
		padding: 121px 0 0px;
	}
`

const SectionHeader = styled.div`
	margin-bottom: 26px;

	@media ${breakpoint('tablet')} {
		margin-bottom: 73px;
	}
`

const HeadingWrapper = styled.div`
	width: 54%;
	text-align: center;
	margin: 0 auto;
	color: ${getColor('white')};

	@media ${breakpoint('tablet')} {
		width: 100%;
		text-align: left;
		color: ${getColor('black')};
	}
`

const SectionBody = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
`

const RepeaterItem = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 70px;
	width: 100%;

	@media ${breakpoint('tablet')} {
		display: flex;
		flex-direction: ${(props) =>
			props.index % 2 === 0 ? 'row' : 'row-reverse'};
		align-items: center;
		justify-content: space-between;
		margin-bottom: 108px;
	}
`

const ImageWrapper = styled.div`
	width: 100%;
	aspect-ratio: 1.012;

	@media ${breakpoint('tablet')} {
		width: 45.5%;
	}
`

const CopyWrapper = styled.div`
	margin-top: 26px;
	color: ${getColor('white')};

	@media ${breakpoint('tablet')} {
		width: 44.37%;
		margin-top: 0px;
		color: ${getColor('black')};
	}
`

export const Copy = styled.p`
	font-size: 14.8px;
	line-height: 17.8px;
	font-weight: 300;
	margin-bottom: 0px;
	color: ${getColor('white')};

	@media ${breakpoint('mobile')} {
		font-size: 18px;
		line-height: 22px;
	}

	@media ${breakpoint('tablet')} {
		color: ${getColor('black')};
	}

	@media ${breakpoint('laptop')} {
		font-size: 25px;
		line-height: 30px;
	}
`

const Title = styled.h3`
	font-size: 20px;
	font-weight: 700;
	line-height: 24px;
	margin-bottom: 20px;

	@media ${breakpoint('tablet')} {
		font-size: 40px;
		line-height: 48px;
		font-weight: 800;
		margin-bottom: 50px;
	}
`

export const SlyleticaForCreators = ({
	heading,
	repeater,
	headingStyles = null,
}) => {
	return (
		<SectionWrapper>
			<ContentContainer>
				<SectionHeader>
					<HeadingWrapper style={headingStyles ? headingStyles : {}}>
						<Heading>{heading && heading}</Heading>
					</HeadingWrapper>
				</SectionHeader>

				<SectionBody>
					{repeater &&
						repeater.map((content, index) => {
							return (
								<RepeaterItem key={index} index={index}>
									<ImageWrapper>
										<BackgroundImage backgroundImage={content.image} />
									</ImageWrapper>
									<CopyWrapper>
										<Title>{content.heading && content.heading}</Title>
										<Copy styles={{ marginBottom: '0px' }}>
											{content.copy && content.copy}
										</Copy>
									</CopyWrapper>
								</RepeaterItem>
							)
						})}
				</SectionBody>
			</ContentContainer>
		</SectionWrapper>
	)
}

export default SlyleticaForCreators
